<template>
    <div style="margin-bottom: 12px; margin-top: 12px;" class="headerWrapper"> 
        <div v-if="targeting && addedSuggestedKeywords?.length>0" class="selectedProductsSection">
            <div class="heading ">Selected keywords
                <img v-b-tooltip title="Remove keyword and re-upload to replace existing one" style="cursor:pointer" alt="img" src="../assets/info.svg"/>
            </div>
            <div class="count">{{ addedSuggestedKeywords?.length }} selected</div>
        </div>
        <div class="selectedKeywordssWrapper"> 
            <table class="suggestedKeywords" style="text-align:left"> 
                <thead class="suggested"> 
                    <tr class="tableRow"> 
                            <th style="min-width: 120px" class="text">Keyword</th>
                            <th class="text" style="min-width: 120px">Match type</th>
                            <th :style="campaignClass === 'Sponsored' ? '' : 'visibility: hidden'" class="text" style="min-width: 120px">Bid</th>
                            <th style="min-width: 120px" @click="$emit('deleteAll')" class="removeBtn">Remove all</th>
                        </tr>
                </thead>
                <tbody class="rowWrapper" > 
                    <tr class="rows productId" v-for="(item, index) in addedSuggestedKeywords" :key="item">
                        <td class="productId categoryClass" v-b-tooltip :title="item.keyword" style="width: 120px;">{{ item.keyword }}</td>
                        <td class="productId" style="width: 120px">{{  item.match_type == 1 ? 'Exact' : item.match_type == 0 ? 'Phrase' : '' }}</td>
                        <td :style="campaignClass === 'Sponsored' ? '' : 'visibility: hidden'" style="width: 120px"> <img alt="img" class="currency productId" src="../assets/currencyIcon.svg">{{ item.bid_price }}</td>
                        <td :disabled="this.isDisabled" style="width: 120px" @click="deleteFromList(index, true)" class="removeBtn">Remove</td>
                    </tr>
                </tbody>
            </table>
        </div>
            </div>
</template>

<script>
import { mapState } from "vuex"


export default({
    name: 'AddedSuggestedKeywords',
    data() {
        return {
        }
    },
    props: {
        targeting: Boolean,
        addedSuggestedKeywords: Array,
    },
    computed: mapState(['campaignClass']),
    methods: {
        deleteFromList(index){
            this.$emit('deleteFromAddedSuggestionsList', index)
        }
    },

    mounted(){
        console.log(this.addedSuggestedKeywords, 'keywords')
    }
    
})
</script>

<style scoped>
 .selectedProductsSection{
    display: flex;
    justify-content: space-between;
    align-content: center;
    margin-bottom: 12px;

    }
    .headerWrapper{
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin-bottom: 12px;
        margin-left: 22px;

    }

    .heading{
        font-weight: 600;
        font-size: 14px;
        line-height: 17px;
        color: #333333;
    }


    .count{
        font-weight: 400;
        font-size: 12px;
        line-height: 15px;
        text-align: center;
        color: #000000;
    }

    .selectedKeywordssWrapper{
        width: 522px;
        height: 504px;
        overflow-x: hidden;
        overflow-y: scroll;
        border: 1px solid #D9D9D9;
        border-radius: 12px;
    }

    .suggestedKeywords{
        width: 100%;
        min-height: 381px;
    }


    .suggested{
        background: #EFEFEF;
        width: 100%;
    }
    .tableRow{
        display: flex;
        padding: 0 30px 0px 24px;
        align-items: center;
        width: 100%;
    }
    .text{
        font-weight: 500;
        font-size: 12px;
        line-height: 21px;
        color: #333333;
    }

    .rowWrapper{
        height: 285px;
        overflow-y: scroll;
    }

    .productId{
        font-weight: 500;
        font-size: 12px;
        line-height: 14px;
        color: #000000A6;
    }

    .rows{
        display: flex;
        align-items: center;
        padding: 0 30px 0px 24px;
        border-bottom: 0.8px solid #D9D9D9;
        height: 40px;
    }
    .targetingRow{
        width: 100% !important;
    }

    .categoryClass{
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }

    .currency{
        height: 10px;
        margin-right: 8px;
    }

    .removeBtn{
        font-weight: 400;
        font-size: 12px;
        line-height: 21px;
        color: #BF0B0B;
        cursor: pointer;
        border: unset;
        background: unset;
        padding: unset;
    }

</style>